<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <div style='width: 160px; margin-top: 7px; margin-right: 10px;'>
        <el-select v-model='searchType' placeholder='请选择' @change='searchTypeChange'
          :clearable='false' size='mini'>
          <el-option v-for='item in searchTypes'
            :key='item.code' :label='item.name' :value='item.code'>
          </el-option>
        </el-select>
      </div>

      <div style='width: 400px; margin-top: 7px; margin-right: 10px;'>
        <TableSelect v-model='itemID' @change='itemChange' ref='itemTableSelect'
          :displayValue='itemNumber ? (itemNumber + "(" + itemName + ")") : ""'
          returnCode='ItemId' displayCode='Number' displayName='Name'
          tableCode='BD_Item'></TableSelect>
      </div>

      <div style='width: 140px; margin-top: 7px; margin-right: 10px;'>
        <el-input-number v-model='qty' style='width: 140px;' @keyup.enter.native='search'
          placeholder='请输入数量' size='mini'></el-input-number>
      </div>

      <el-button type='primary' icon='sys sys-search' class='navbarbtn'
        @click='search'>
        查 找
      </el-button>
      <el-button type='primary' icon='sys sys-export' class='navbarbtn'
        @click='exportBom'>
        导 出
      </el-button>
    </div>

    <div style='margin-top: 2px; margin-right: 10px;'>
      <el-select v-model='stockIDs' placeholder='请选择仓库' multiple size='mini' style='width: 100%'>
        <el-option v-for='stock in stocks'
          :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
        </el-option>
      </el-select>
    </div>

    <el-table :data='searchData' border :height='getTableHeight()' v-if='searchType === "1"'
      :cell-style='{ padding: "0px" }' size='medium' ref='1Table'
      style='margin-top: 0px;'>
      <el-table-column type='index' label='序号' width='60'>
      </el-table-column>
      <el-table-column prop='Level' label='层级' width='100'>
      </el-table-column>
      <el-table-column prop='Number' label='产品代码' width='180'>
      </el-table-column>
      <el-table-column prop='Name' label='产品名称' width='200'>
      </el-table-column>
      <el-table-column prop='Qty' label='可生产总量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat((scope.row.Qty ? scope.row.Qty : 0).toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='SQty' label='单位标准产量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat((scope.row.SQty ? scope.row.SQty : 0).toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='InvQty' label='库存量' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.InvQty ? parseFloat(parseFloat(scope.row.InvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='GCInvQty' label='工程仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.GCInvQty ? parseFloat(parseFloat(scope.row.GCInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='BLInvQty' label='不良仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.BLInvQty ? parseFloat(parseFloat(scope.row.BLInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='DJInvQty' label='待检仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.DJInvQty ? parseFloat(parseFloat(scope.row.DJInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='UnitName' label='单位' width='80'>
      </el-table-column>
      <el-table-column prop='Model' label='产品规格' width='400'>
      </el-table-column>
      <el-table-column prop='Supplier' label='供应商' width='200'>
      </el-table-column>
      <el-table-column prop='Customer' label='客户' width='200'>
      </el-table-column>
    </el-table>

    <el-table :data='searchData' border :height='getTableHeight()' v-if='searchType === "2" && (qty <= 0 || showEnoughItem)'
      :cell-style='table2CellStyle' size='medium' ref='2Table'
      style='margin-top: 0px;'>
      <el-table-column type='index' label='序号' width='60'>
      </el-table-column>
      <el-table-column prop='Level' label='层级' width='100'>
      </el-table-column>
      <el-table-column prop='Number' label='材料代码' width='180'>
      </el-table-column>
      <el-table-column prop='Name' label='材料名称' width='200'>
      </el-table-column>
      <el-table-column prop='SQty' label='单位需求量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat(scope.row.SQty.toFixed(6))}}
        </template>
      </el-table-column>
      <el-table-column prop='InvQty' label='库存量' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.InvQty ? parseFloat(parseFloat(scope.row.InvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='GCInvQty' label='工程仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.GCInvQty ? parseFloat(parseFloat(scope.row.GCInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='BLInvQty' label='不良仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.BLInvQty ? parseFloat(parseFloat(scope.row.BLInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='DJInvQty' label='待检仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.DJInvQty ? parseFloat(parseFloat(scope.row.DJInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='CanProduceQty' label='库存可生产量' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.InvQty ? parseFloat((parseFloat(scope.row.InvQty) / scope.row.SQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='UnitName' label='单位' width='80'>
      </el-table-column>
      <el-table-column prop='Model' label='材料规格' width='400'>
      </el-table-column>
      <el-table-column prop='Supplier' label='供应商' width='200'>
      </el-table-column>
      <el-table-column prop='Customer' label='客户' width='200'>
      </el-table-column>
    </el-table>

    <el-table :data='searchData' border :height='getTableHeight()' v-if='searchType === "2" && (qty > 0 && !showEnoughItem)'
      :cell-style='table2CellStyle' size='medium' ref='2Table'
      style='margin-top: 0px;'>
      <el-table-column type='index' label='序号' width='60'>
      </el-table-column>
      <el-table-column prop='Level' label='层级' width='100'>
      </el-table-column>
      <el-table-column prop='Number' label='材料代码' width='180'>
      </el-table-column>
      <el-table-column prop='Name' label='材料名称' width='200'>
      </el-table-column>
      <el-table-column prop='Qty' label='所需总量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat(scope.row.Qty.toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='SQty' label='单位需求量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat(scope.row.SQty.toFixed(6))}}
        </template>
      </el-table-column>
      <el-table-column prop='InvQty' label='库存量' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.InvQty ? parseFloat(parseFloat(scope.row.InvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='GCInvQty' label='工程仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.GCInvQty ? parseFloat(parseFloat(scope.row.GCInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='BLInvQty' label='不良仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.BLInvQty ? parseFloat(parseFloat(scope.row.BLInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='DJInvQty' label='待检仓' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.DJInvQty ? parseFloat(parseFloat(scope.row.DJInvQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='CanProduceQty' label='库存可生产量' width='120' align='right'>
        <template #default='scope'>
          {{scope.row.InvQty ? parseFloat((parseFloat(scope.row.InvQty) / scope.row.SQty).toFixed(4)) : 0}}
        </template>
      </el-table-column>
      <el-table-column prop='MoreNeedQty' label='库存缺少量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat((scope.row.MoreNeedQty ? scope.row.MoreNeedQty : 0).toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='NeedICMOQty' label='需下工单量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat((scope.row.NeedICMOQty ? scope.row.NeedICMOQty : 0).toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='MoreQty' label='库存超出量' width='120' align='right'>
        <template #default='scope'>
          {{parseFloat((scope.row.MoreQty ? scope.row.MoreQty : 0).toFixed(4))}}
        </template>
      </el-table-column>
      <el-table-column prop='UnitName' label='单位' width='80'>
      </el-table-column>
      <el-table-column prop='Model' label='材料规格' width='400'>
      </el-table-column>
      <el-table-column prop='Supplier' label='供应商' width='200'>
      </el-table-column>
      <el-table-column prop='Customer' label='客户' width='200'>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import TableSelect from '@/components/custom/TableSelect.vue'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import exportExcelHelper from '@/components/export/ExportExcelHelper'

export default {
  name: 'CompleteSetsSearch',
  components: {
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',

      searchTypes: [
        { code: '1', name: '查找可生产成品数' },
        { code: '2', name: '查找所需原材料数' }
      ],

      searchType: '2',
      itemID: '',
      itemNumber: '',
      itemName: '',
      qty: 0,
      showEnoughItem: false,
      stockIDs: [],

      searchData: [],
      stocks: []
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title

    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0' AND IncludeAccounting='True' AND CompleteSetComputer='1'")
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 物料选择方法
    itemChange: async function (row) {
      const that = this
      that.itemNumber = row.Number
      that.itemName = row.Name
      if (that.searchType === '1') {
        if (that.itemID) {
          const loadingInstance = Loading.service({ fullscreen: true })
          const rtnObj = await axiosHelper.handle('/WebAction/QueryAnalysis.CompleteSetsSearch.GetERPInvertory', {
            itemID: that.itemID,
            stockIDs: that.stockIDs
          })
          if (rtnObj.error === '000000') {
            that.qty = rtnObj.qty
          } else {
            that.$message.error(rtnObj.msg)
          }
          loadingInstance.close()
        }
      }
      that.search()
    },

    getTableHeight: function () {
      return window.innerHeight - 200
    },

    searchTypeChange: function () {
      const that = this
      that.searchData = []
      that.qty = 0
      that.itemID = ''
      that.itemNumber = ''
      that.itemName = ''
      that.$refs.itemTableSelect.clearSelect()
    },

    // 查找
    search: async function () {
      const that = this
      if (!that.qty) {
        that.qty = 0
      }
      if (!that.itemID) {
        that.$message.error('请选择物料！')
        return
      }
      if (parseFloat(that.qty) < 0) {
        that.$message.error('数量不能小于0！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/QueryAnalysis.CompleteSetsSearch.Search', {
        itemID: that.itemID,
        searchType: that.searchType,
        qty: that.qty,
        showEnoughItem: that.showEnoughItem,
        stockIDs: that.stockIDs
      })
      if (rtnObj.error === '000000') {
        that.searchData = rtnObj.searchData
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    table2CellStyle: function ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'MoreNeedQty') {
        if (row.MoreNeedQty > 0) {
          return { 'background-color': 'Tomato' }
        }
      } else if (column.property === 'NeedICMOQty') {
        if (row.NeedICMOQty > 0) {
          return { 'background-color': 'lightblue' }
        }
      }
      return {}
    },

    exportBom: function () {
      const that = this
      if (that.searchData.length <= 0) {
        that.$message.error('没有可以导出的数据！')
        return
      }
      if (that.searchType === '1') {
        const exportData = [['序号', '层级', '产品代码', '产品名称', '可生产总量', '单位标准产量', '库存量', '单位', '产品规格', '供应商', '客户']]
        for (let i = 0; i < that.searchData.length; i++) {
          exportData.push([
            i + 1,
            that.searchData[i].Level,
            that.searchData[i].Number,
            that.searchData[i].Name,
            that.searchData[i].Qty,
            that.searchData[i].SQty,
            that.searchData[i].InvQty,
            that.searchData[i].UnitName,
            that.searchData[i].Model,
            that.searchData[i].Supplier,
            that.searchData[i].Customer
          ])
        }
        const ws = exportExcelHelper.arraySimpleToWSData(exportData)
        const wss = []
        wss.push({ sheetName: 'sheet1', data: ws })
        exportExcelHelper.exportWssToExcel(wss, that.itemNumber + '齐套数查询')
      } else if (that.searchType === '2' && (that.qty <= 0 || that.showEnoughItem)) {
        const exportData = [['序号', '层级', '材料代码', '材料名称', '单位需求量', '库存量', '库存可生产量', '单位', '材料规格', '供应商', '客户']]
        for (let i = 0; i < that.searchData.length; i++) {
          exportData.push([
            i + 1,
            that.searchData[i].Level,
            that.searchData[i].Number,
            that.searchData[i].Name,
            that.searchData[i].SQty,
            that.searchData[i].InvQty,
            that.searchData[i].InvQty && that.searchData[i].SQty
              ? parseFloat((parseFloat(that.searchData[i].InvQty) / that.searchData[i].SQty).toFixed(4))
              : 0,
            that.searchData[i].UnitName,
            that.searchData[i].Model,
            that.searchData[i].Supplier,
            that.searchData[i].Customer
          ])
        }
        const ws = exportExcelHelper.arraySimpleToWSData(exportData)
        const wss = []
        wss.push({ sheetName: 'sheet1', data: ws })
        exportExcelHelper.exportWssToExcel(wss, that.itemNumber + '齐套数查询')
      } else if (that.searchType === '2' && (that.qty > 0 || !that.showEnoughItem)) {
        const exportData = [['序号', '层级', '材料代码', '材料名称', '所需总量', '单位需求量', '库存量', '库存可生产量',
          '库存缺少量', '需下工单量', '库存超出量', '单位', '材料规格', '供应商', '客户']]
        for (let i = 0; i < that.searchData.length; i++) {
          exportData.push([
            i + 1,
            that.searchData[i].Level,
            that.searchData[i].Number,
            that.searchData[i].Name,
            that.searchData[i].Qty,
            that.searchData[i].SQty,
            that.searchData[i].InvQty,
            that.searchData[i].InvQty && that.searchData[i].SQty
              ? parseFloat((parseFloat(that.searchData[i].InvQty) / that.searchData[i].SQty).toFixed(4))
              : 0,
            that.searchData[i].MoreNeedQty,
            that.searchData[i].NeedICMOQty,
            that.searchData[i].MoreQty,
            that.searchData[i].UnitName,
            that.searchData[i].Model,
            that.searchData[i].Supplier,
            that.searchData[i].Customer
          ])
        }
        const ws = exportExcelHelper.arraySimpleToWSData(exportData)
        const wss = []
        wss.push({ sheetName: 'sheet1', data: ws })
        exportExcelHelper.exportWssToExcel(wss, that.itemNumber + '齐套数查询')
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
